// Quadro no topo das páginas + tela cheia de verdade (0.65, C10): ocupa a tela inteira, de borda a borda,
// com a barra flutuante e compacta; o mesmo ⛶ sai da tela cheia. No tablet dá para girar e usar deitado.
import { useEffect, useState } from 'react';
import { Modal, Platform, StatusBar, View, useWindowDimensions } from 'react-native';
import { useTamanho } from '../lib/tamanho';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import type { AbaId, Folha, Quadro as Q } from '../store/types';
import { Quadro, quadroVazio } from './Quadro';
import { C } from './theme';

async function girarLivre(livre: boolean) {
  if (Platform.OS === 'web') return;
  try {
    const Device = require('expo-device');
    if (Device.deviceType !== Device.DeviceType?.TABLET) return;
    const SO = require('expo-screen-orientation');
    if (livre) await SO.unlockAsync(); else await SO.lockAsync(SO.OrientationLock.PORTRAIT_UP);
  } catch { /* app antigo, sem o módulo */ }
}

export function QuadroPagina({ valor, onChange, cor, aba, altura = 300, onAplicarTodas, rotuloTodas, nome, onRolagem, encherTela }: {
  valor?: Q | null; onChange: (q: Q) => void; cor: string; aba?: AbaId | null; altura?: number;
  onAplicarTodas?: (f: Folha) => void; rotuloTodas?: string; nome?: string; onRolagem?: (pode: boolean) => void;
  /** texto 20 (7): a folha vai até o pé da tela */
  encherTela?: boolean;
}) {
  const [cheio, setCheio] = useState(false);
  const ins = useSafeAreaInsets();
  const q = valor ?? quadroVazio();
  // texto 18 A7: no computador (janela central "Página"), a folha ocupa pelo menos 60% da altura da janela
  const { height: altTela } = useWindowDimensions();
  const largo = useTamanho() !== 'celular';
  const alturaFolha = largo ? Math.max(altura, Math.round(Math.min(820, altTela - 48) * 0.6)) : altura;
  useEffect(() => { girarLivre(cheio); return () => { if (cheio) girarLivre(false); }; }, [cheio]);
  const comum = { valor: q, onChange, cor, aba, onAplicarTodas, rotuloTodas, nome };
  return (
    <View>
      {!cheio && <Quadro {...comum} altura={alturaFolha} encherTela={encherTela} onTelaCheia={() => setCheio(true)} onRolagem={onRolagem} />}
      <Modal visible={cheio} animationType="fade" onRequestClose={() => setCheio(false)} presentationStyle="fullScreen" supportedOrientations={['portrait', 'landscape']}>
        <StatusBar hidden />
        <View style={{ flex: 1, backgroundColor: C.bg, paddingTop: Platform.OS === 'ios' ? ins.top : 0 }}>
          <Quadro {...comum} telaCheia onTelaCheia={() => setCheio(false)} />
        </View>
      </Modal>
    </View>
  );
}
